import { render, staticRenderFns } from "./TheLayoutHeader.vue?vue&type=template&id=245b7b42&scoped=true&"
import script from "./TheLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./TheLayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutHeader.vue?vue&type=style&index=0&id=245b7b42&lang=scss&scoped=true&"
import style1 from "./TheLayoutHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b7b42",
  null
  
)

component.options.__file = "TheLayoutHeader.vue"
export default component.exports